import { getorderlist } from '../../api';

export const NAMESPACE = 'orderList';

export const UPDATE_LIST = `UPDATE_LIST_${NAMESPACE}`;
export const UPDATE_PENDING_LIST = `UPDATE_PENDING_LIST_${NAMESPACE}`;
export const UPDATE_PAGINATION = `UPDATE_PAGINATION_${NAMESPACE}`;
export const UPDATE_CURRENTPAGE = `UPDATE_CURRENTPAGE_${NAMESPACE}`;
export const UPDATE_SEARCH_CONDITION = `UPDATE_SEARCH_CONDITION_${NAMESPACE}`;
export const UPDATE_STATUS_LIST = `UPDATE_STATUS_LIST_${NAMESPACE}`;
export const UPDATE_ORDER_STATUS = `UPDATE_ORDER_STATUS_${NAMESPACE}`;
export const UPDATE_LIST_ORDER = `UPDATE_LIST_ORDER_${NAMESPACE}`;
export const RESET_ALL = `RESET_ALL_${NAMESPACE}`;

const s = {
  statusList: [],
  pendingList: [],
  list: [],
  pagination: {
    total: 0,
    perpage: 50,
  },
  currentPage: 1,
  searchCondition: {
    order_id: '',
    rider_name: '',
    shop_name: '',
  },
  orderStatus: 0,
  orderByCol: {
    prop: null,
    order: null,
  },
};

const getters = {
};

const actions = {
  handleListSortChange({ commit, dispatch }, column) {
    commit(UPDATE_LIST_ORDER, column);
    dispatch('getOrderListData');
  },
  handleOrderStatusChange({ commit, dispatch }, status) {
    commit(UPDATE_ORDER_STATUS, status);
    dispatch('getOrderListData');
  },
  handleCurrentPageChange({ commit, dispatch }, page) {
    commit(UPDATE_CURRENTPAGE, page);
    dispatch('getOrderListData');
  },
  resetAllListData({ commit }) {
    commit(RESET_ALL);
  },
  getPendingListData({ commit, rootState, rootGetters }) {
    const { timestamp, aside } = rootState;
    const { AoiShopMode } = aside;
    const { AoiShopMsg } = rootGetters;
    if (AoiShopMsg) {
      const params = {
        time: timestamp,
        dispatch_type: AoiShopMode,
        aoi_id: AoiShopMsg.aoi_id,
        shop_id: AoiShopMsg.shop_id,
        order_status: 'pending',
      };
      getorderlist({
        ...params,
      }).then((data) => {
        if ((data.errno === 0 || data.errno === '0') && data.data) {
          if (data.data.list) {
            commit(UPDATE_PENDING_LIST, data.data.list);
          }
        }
      });
    }
  },
  getOrderListData({ commit, state, rootState, rootGetters }, condition) {
    const { timestamp, aside } = rootState;
    const { AoiShopMode } = aside;
    const { AoiShopMsg } = rootGetters;
    const { currentPage, pagination, orderStatus, statusList, orderByCol } = state;
    if (AoiShopMsg) {
      const params = {
        time: timestamp,
        dispatch_type: AoiShopMode,
        aoi_id: AoiShopMsg.aoi_id,
        shop_id: AoiShopMsg.shop_id,
        perpage: pagination.perpage,
        page: currentPage,
        order_status: orderStatus !== 0 ? statusList[orderStatus].label : null,
        ...(orderByCol.prop && { sort: orderByCol.prop }),
        ...(orderByCol.order && { is_asc: orderByCol.order === 'descending' ? 0 : 1 }),
      };
      getorderlist({
        ...params,
        ...condition,
      }).then((data) => {
        if ((data.errno === 0 || data.errno === '0') && data.data) {
          commit(UPDATE_PAGINATION, {
            ...state.pagination,
            total: data.data.total,
          });
          if (data.data.list) {
            commit(UPDATE_LIST, data.data.list);
          }
          if (data.data.status_list) {
            commit(UPDATE_STATUS_LIST, data.data.status_list);
          }
        }
      });
    }
  },
};

const mutations = {
  // eslint-disable-next-line no-unused-vars
  [RESET_ALL](state) {
    state.statusList = [];
    state.pendingList = [];
    state.list = [];
    state.pagination = {
      total: 0,
      perpage: 50,
    };
    state.currentPage = 1;
  },
  [UPDATE_LIST](state, payload) {
    state.list = payload;
  },
  [UPDATE_PENDING_LIST](state, payload) {
    state.pendingList = payload;
  },
  [UPDATE_CURRENTPAGE](state, payload) {
    state.currentPage = payload;
  },
  [UPDATE_LIST_ORDER](state, column) {
    const { prop, order } = column;
    state.orderByCol = {
      prop,
      order,
    };
  },
  [UPDATE_STATUS_LIST](state, payload) {
    state.statusList = [{ label: '', text: '全部' }, ...payload];
  },
  [UPDATE_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [UPDATE_ORDER_STATUS](state, payload) {
    state.orderStatus = payload;
  },
  [UPDATE_SEARCH_CONDITION](state, payload) {
    state.searchCondition = payload;
  },
};

export default {
  namespaced: true,
  state: s,
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/pages/homepage/store/modules/orderList.js